import instance from '@apis/instance';
import { ColorSchemeResponse } from '@models/colorScheme';

class ColorSchemeApi {
  static getColorScheme(): Promise<ColorSchemeResponse> {
    return instance.get('/color-scheme');
  }
}

export default ColorSchemeApi;
